import axiosInstance from '@/services/interceptor.services';

export interface Notification {
  id: string;
  subject: string;
  title?: string;
  body?: string;
  status: 'read' | 'unread';
  restaurantId?: string;
  orderId?: string;
  createdAt?: string;
  [key: string]: unknown;
}

export interface NotificationSearchResponse {
  message: unknown;
  count: number;
  total: number;
  page: number;
  pageSize: number;
  data?: Notification[];
}

export const NotificationService = {
  getById: async (notificationId: string) => {
    const { data } = await axiosInstance.get(
      `notifications/get/${notificationId}`,
    );
    return data;
  },

  search: async (params?: {
    page?: number;
    pageSize?: number;
    pagination?: boolean;
    restaurantId?: string;
    orderId?: string;
    status?: 'read' | 'unread';
    subject?: string;
  }): Promise<NotificationSearchResponse> => {
    const { data } = await axiosInstance.get('notifications/search', {
      params,
    });
    return data;
  },

  markAsRead: async (notificationId: string) => {
    const { data } = await axiosInstance.put(
      `notifications/read/${notificationId}`,
    );
    return data;
  },

  delete: async (notificationId: string) => {
    const { data } = await axiosInstance.delete(
      `notifications/delete/${notificationId}`,
    );
    return data;
  },
};
